import { shallowEqual, useSelector } from 'react-redux';
import type { LocationState } from 'redux-first-router';

export function useLocation() {
  return useSelector<{ location: LocationState }, LocationState>(
    (state) => state.location,
    shallowEqual
  );
}
